import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-gradient-heading',
    standalone: true,
    imports: [],
    templateUrl: './gradient-heading.component.html',
    styleUrl: './gradient-heading.component.scss'
})
export class GradientHeadingComponent {
    @Input() text = '';
    @Input() styles: { [key: string]: any };
    constructor() {}
}
